<template>
  <div class="df jcc fdc aic">
    <p class="title">请使用Cupshe账号登录</p>
    <a-form
      ref="formRef"
      :model="formState"
      :rules="rules"
      style="width: 280px;"
      :class="{
        'is-error': isFormError
      }"
    >
      <a-form-item name="account">
        <a-input
          placeholder="请输入账号"
          v-model:value.trim="formState.account"
          @focus="isFormError = false"
        />
      </a-form-item>
      <a-form-item name="password">
        <a-input-password
          placeholder="请输入密码"
          v-model:value.trim="formState.password"
          @focus="isFormError = false"
        ></a-input-password>
      </a-form-item>

      <a-form-item>
        <p class="error-submit-msg">
          {{ errorMsg }}
        </p>
        <a-button type="primary" @click="onSubmit" block>登录</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script setup>
import { usePasswordLogin } from '../hook'
import { useStore } from 'vuex'
// 创建store对象
const store = useStore()

const {
  formState,
  formRef,
  errorMsg,
  isFormError,
  rules,
  onSubmit
} = usePasswordLogin(store)
</script>
<style lang="scss" scoped>
:deep .portal-ant-form-item-with-help {
  margin-bottom: 12px;
}
.title {
  padding: 39px 0 24px 0;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}
.is-error :deep .portal-ant-input,
.is-error :deep .portal-ant-input-affix-wrapper {
  border-color: #ff4d4f;
}

.error-submit-msg {
  display: none;
}
.is-error .error-submit-msg {
  display: block;
  background: rgba(250, 80, 80, 0.15);
  padding: 8px 12px;
  color: #fa5050;
  line-height: normal;
  margin-top: -12px;
  margin-bottom: 12px;
}
</style>
